import { useSelector } from "react-redux";
import { StateExtended } from "../../interfaces/StateExtended";

export const useAppUserDetailsSelector = () => useSelector((state: StateExtended) => state.user.user);

export const useAppUserAuthSelector = () => useSelector((state: StateExtended) => state.user.isAuthenticated);

export const useAppUserTokenSelector = () => useSelector((state: StateExtended) => state.user.token);

export const useAppGuestUserIdSelector = () => useSelector((state: StateExtended) => state.user.guestUserId);

export const useAppPickIdsSelector = () => useSelector((state: StateExtended) => state.user.pickIds);
